import { Delete, Info, LockPerson, VerifiedUser } from "@mui/icons-material";
import { fieldTypes } from "../../components/Form";
import { TableConfig } from "../../components/Table/Table";
import { IExpense } from "../../types/IExpense";
import { getShortId } from "../../utils/commonHelpers";
import { IExpenseHierarchy } from "../../types/IExpenseHierarchy";

export const getFormFields = (
  expenseTypeOptions: {
    label: string;
    value: string;
    group: string;
  }[],
  expenseSourceOptions: {
    label: string;
    value: string;
  }[],
) => [
  {
    key: "source_id",
    label: "Expense Source",
    type: fieldTypes.AUTO_COMPLETE,
    placeholder: "Expense Source",
    required: true,
    multiple: false,
    options: expenseSourceOptions,
    selectFirstByDefault: true,
  },
  {
    key: "type_id",
    label: "Expense Type",
    type: fieldTypes.AUTO_COMPLETE,
    placeholder: "Expense Type",
    required: true,
    multiple: false,
    options: expenseTypeOptions,
  },
  {
    key: "description",
    label: "Description",
    type: fieldTypes.TEXT,
    placeholder: "Description",
    required: true,
    multiline: true,
  },
  {
    key: "date_time",
    label: "Date & Time",
    type: fieldTypes.DATETIME,
    required: true,
  },
  {
    key: "amount",
    label: "Amount",
    type: fieldTypes.NUMBER,
    placeholder: "Amount",
    required: true,
  },
  {
    key: "is_private",
    label: "Private",
    type: fieldTypes.CHECKBOX,
    placeholder: "Amount",
    options: [
      {
        label: "Private",
        value: "private",
      },
    ],
  },
];

export const getExpenseDetailTableConfig = (
  data: IExpenseHierarchy,
  handleDeleteExpense: (expense: IExpense) => Promise<void>,
): TableConfig => ({
  rowIdentifierKey: "id",
  data: data.base_expense_types,
  columns: [
    {
      name: "Title",
      valueOrProcessor: "title",
    },
    {
      name: "Spending",
      valueOrProcessor: "spending",
    },
  ],
  subConfig: {
    rowIdentifierKey: "id",
    dataKey: "expense_types",
    columns: [
      {
        name: "Title",
        valueOrProcessor: "title",
      },
      {
        name: "Spending",
        valueOrProcessor: "spending",
      },
    ],

    subConfig: {
      rowIdentifierKey: "id",
      dataKey: "expenses",
      columns: [
        {
          name: "Source",
          valueOrProcessor: "source.title",
        },
        {
          name: "Date & Time",
          valueOrProcessor: "date_time",
          formatter: "date",
        },
        {
          name: "Type",
          valueOrProcessor: (expense) => (
            <>
              {" "}
              {expense.is_private ? (
                <LockPerson className="is-private-icon" fontSize="inherit" />
              ) : (
                <VerifiedUser className="is-private-icon" fontSize="inherit" />
              )}
              {expense.base_type_title}
              {" / "} {expense.type_title}
            </>
          ),
        },
        {
          name: "Description",
          valueOrProcessor: "description",
        },
        {
          name: "Amount",
          valueOrProcessor: "amount",
        },
        {
          name: "Entry Date & Time",
          valueOrProcessor: "created_at",
          formatter: "date",
        },

        {
          name: "Action",
          valueOrProcessor: (expense) => (
            <>
              <Info
                className="icon"
                color="action"
                onClick={() => alert(getShortId(expense.id))}
              />
              <Delete
                color="error"
                className="icon"
                onClick={() => handleDeleteExpense(expense)}
              />
            </>
          ),
        },
      ],
    },
  },
});
